module.exports = __webpack_public_path__ + "img/logos.d85b3ad.png";